var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page-title"}},[_c('br'),_c('span',{staticClass:"text-h5",style:(_vm.functions.getCssCorEscura())},[_c('strong',[_vm._v(_vm._s(_vm.title))])]),_c('p',{style:(_vm.functions.getCssCorEscura())},[_vm._v(" "+_vm._s(_vm.subtitle)+" "),_c('strong',[_vm._v(_vm._s(_vm.subtitleStrong))])]),_c('hr'),_c('br')])
}
var staticRenderFns = []

export { render, staticRenderFns }